module.exports = __webpack_public_path__ + "assets/images/popups/ok_interstitial_ru.png";